import React from 'react';
import { Popover, Box, Typography, Divider } from '@mui/material';

export interface TaxBreakdownItem {
  label: string;
  value: string;
  subLabel?: string;
  isBold?: boolean;
}

export interface TaxBreakdownPopoverProps {
  // Controls
  open: boolean;
  anchorEl: HTMLElement | null;
  onClose: () => void;

  // Content
  title: string;
  items: TaxBreakdownItem[];
}

const TaxBreakdownPopover: React.FC<TaxBreakdownPopoverProps> = ({
  open,
  anchorEl,
  onClose,
  title,
  items,
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      disableRestoreFocus
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      transformOrigin={{ vertical: 'top', horizontal: 'left' }}
      slotProps={{
        paper: {
          sx: {
            p: 1.5,
            borderRadius: 2,
            minWidth: 220,
          },
        },
      }}
    >
      <Box sx={{ px: 0.5 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          {title}
        </Typography>
        <Divider sx={{ mb: 1 }} />
        {items.map((item, index) => (
          <Box
            key={index}
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'baseline',
              py: 0.5,
              ...(item.isBold && {
                borderTop: '1px solid',
                borderColor: 'divider',
                mt: 0.5,
                pt: 1,
              }),
            }}
          >
            <Box>
              <Typography
                variant="body2"
                sx={{ fontWeight: item.isBold ? 700 : 400 }}
              >
                {item.label}
              </Typography>
              {item.subLabel && (
                <Typography variant="caption" color="text.secondary">
                  {item.subLabel}
                </Typography>
              )}
            </Box>
            <Typography
              variant="body2"
              sx={{ fontWeight: item.isBold ? 700 : 600 }}
            >
              {item.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Popover>
  );
};

export default TaxBreakdownPopover;